// extracted by mini-css-extract-plugin
export default {"left-menu":"LeftMenu_left-menu__pa8-o"};